class MelProjectToggle extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._links = this.querySelectorAll('[data-js-project-nav-link]');
    this._imageContainer = this.querySelector('[data-js-project-nav-image]');
    return self;
  }

  static get is() {
    return 'mel-project-toggle';
  }

  static get observedAttributes() {
    return ['current-image'];
  }

  get currentImage() {
    return this.getAttribute('current-image');
  }

  connectedCallback() {
    if (!this._links.length) return;

    this._addEventListeners();
    this._bindHandlers();
  }

  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'current-image':
        this._imageChanged();
    }
  }

  _addEventListeners() {
    this._links.forEach(link => {
      link.addEventListener('mouseenter', e => {
        const image = e.target.getAttribute('data-shape');

        if (image) {
          this.setAttribute('current-image', image);
        }
      });
    });
  }

  _bindHandlers() {
  }

  _imageChanged() {
    this._imageContainer.src = this.currentImage;
  }
}

customElements.define(MelProjectToggle.is, MelProjectToggle);
